import React from "react";
import HeroSection from "../components/Hero";
import ProductList from "./Product";


import SubscribeSection from "../components/Newsletter";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div>
     
     
     <ProductList/>
     
    </div>
  );
}
